// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-dashboard {
  padding: 0.5rem 0 1rem;
}

::ng-deep .admin-dashboard-tabs .p-tabview-nav-link {
  padding: 12px 16px;
}
::ng-deep .admin-dashboard-tabs .admin-tab-icon {
  margin-right: 8px;
  font-size: 14px;
}
::ng-deep .admin-dashboard-tabs .p-tabview-panels {
  padding: 16px 0 0;
  background: transparent;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
